import { useEffect } from 'react';

// The success URL carries the claim token; a no-referrer policy keeps it out of the
// Referer header on any outbound request or navigation from this page.
export function useNoReferrerPolicy(): void {
  useEffect(() => {
    const meta = document.createElement('meta');
    meta.name = 'referrer';
    meta.content = 'no-referrer';
    document.head.appendChild(meta);
    return () => {
      document.head.removeChild(meta);
    };
  }, []);
}
